var ref;

if (typeof Groupon !== "undefined" && Groupon !== null ? (ref = Groupon.Performance) != null ? ref.pageReady : void 0 : void 0) {
  Groupon.Performance.pageReady();
}

require('../../modules/optimize_config/frontend/optimize_config');

require('../../modules/ad_inventory_for_gsm/frontend/ad_inventory_dfp');

require('../../modules/deals/frontend/toggle');

require('../../modules/seo-platform-editorial/frontend/editorial_widget');

require('../../modules/deals/frontend/update');

require('../../modules/helpers/frontend/html');

$(document).ready(function() {
  return Groupon.ui.GSMEditorialWidget.initWidget();
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvZHNlaWZlcnQvbmFwaXN0cmFuby9idWlsZC8xNDk2Nzk1ODExNDM3LTYzMDAxL3JlbGVhc2UtMTAuMS4xMS9zZW9fcGxhdGZvcm1faXRpZXIvY29yZS9mcm9udGVuZC9sb2NhbC1ob21lLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2RzZWlmZXJ0L25hcGlzdHJhbm8vYnVpbGQvMTQ5Njc5NTgxMTQzNy02MzAwMS9yZWxlYXNlLTEwLjEuMTEvc2VvX3BsYXRmb3JtX2l0aWVyL2NvcmUvZnJvbnRlbmQvbG9jYWwtaG9tZS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxrR0FBdUIsQ0FBRSwyQkFBekI7RUFDRSxPQUFPLENBQUMsV0FBVyxDQUFDLFNBQXBCLENBQUEsRUFERjs7O0FBR0EsT0FBQSxDQUFRLHdEQUFSOztBQUVBLE9BQUEsQ0FBUSw4REFBUjs7QUFDQSxPQUFBLENBQVEscUNBQVI7O0FBQ0EsT0FBQSxDQUFRLGdFQUFSOztBQUNBLE9BQUEsQ0FBUSxxQ0FBUjs7QUFDQSxPQUFBLENBQVEscUNBQVI7O0FBRUEsQ0FBQSxDQUFFLFFBQUYsQ0FBVyxDQUFDLEtBQVosQ0FBa0IsU0FBQTtTQUNoQixPQUFPLENBQUMsRUFBRSxDQUFDLGtCQUFrQixDQUFDLFVBQTlCLENBQUE7QUFEZ0IsQ0FBbEIifQ==
